// Plugins
import axios from '@/plugins/axios';
import dayjs from '@/plugins/dayjs';

export function registerPlugins(app) {
    app.use(axios)
        .use(dayjs)
}
